import React from 'react'
import { Form, Row, Col, Collapse } from 'antd'
import i18next from 'i18next'
import FormulaIdField from './FormulaIdField'
import FormulaNameField from './FormulaNameField'
import FormulaCodeField from './FormulaCodeField'
import FormulaAggregationTypeField from './FormulaAggregationTypeField'
import FormulaTypeField from './FormulaTypeField'
import FormulaDecimalsField from './FormulaDecimalsField'
import FormulaStyleField from './FormulaStyleField'
import TranslateFields from '../../../../components/Form/TranslateFields'
import FormulaAddFunctionAndSourceWrapper from './FormulaAddFunctionAndSourceWrapper'
import FormulaReferenceRulesField from './FormulaReferenceRulesField'

export type FormItemType =
  | 'id'
  | 'name'
  | 'translations'
  | 'code'
  | 'advancedSettings'
  | 'functionAndSource'
  | 'referenceRules'

export interface FormItemsConfig {
  items: FormItemType[]
}

export const FULL_FORM_CONFIG: FormItemsConfig = {
  items: ['id', 'name', 'translations', 'code', 'advancedSettings', 'functionAndSource', 'referenceRules']
}

export const renderFormItem = (itemType: FormItemType, formulaError?: any): React.ReactElement | null => {
  switch (itemType) {
    case 'id':
      return <FormulaIdField key="id" />
    case 'name':
      return <FormulaNameField key="name" />
    case 'translations':
      return (
        <Collapse key="translations-accordion" style={{ marginBottom: 8 }}>
          <Collapse.Panel header={i18next.t('global:translations')} key="translations" forceRender>
            <TranslateFields />
          </Collapse.Panel>
        </Collapse>
      )
    case 'code':
      return <FormulaCodeField key="code" />
    case 'functionAndSource':
      return <FormulaAddFunctionAndSourceWrapper key="functionAndSource" formulaError={formulaError} />
    case 'referenceRules':
      return <FormulaReferenceRulesField key="referenceRules" />
    case 'advancedSettings':
      return (
        <Collapse key="settings-accordion" style={{ marginBottom: 8 }}>
          <Collapse.Panel header={i18next.t('global:advancedSettings')} key="settings" forceRender>
            <FormulaAggregationTypeField />
            <Form.Item noStyle>
              <Row gutter={24}>
                <Col>
                  <FormulaTypeField />
                </Col>
                <Col>
                  <FormulaDecimalsField />
                </Col>
              </Row>
            </Form.Item>
            <FormulaStyleField />
          </Collapse.Panel>
        </Collapse>
      )
    default:
      return null
  }
}

export const renderFormItems = (config: FormItemsConfig, formulaError?: any): React.ReactElement[] => {
  return config.items.map(itemType => renderFormItem(itemType, formulaError)).filter(Boolean) as React.ReactElement[]
}
